import React from 'react';
import { Row, Col } from 'reactstrap';
import { v4 as uuid } from 'uuid';

import { postTypeToString } from '../../../../Utils/Converters';

import './Organisers.css';

function Organisers(props) {
    const { organisers } = props;

    if (organisers.length > 0) {
        let post = null;
        let organiserItems = organisers.map(organiser => {
            let prevPost = post;
            post = organiser.post;

            if (organiser.post === prevPost)
                return (
                    <li key={uuid()}>
                        {organiser.name}
                    </li>
                );
            else
                return [
                    <li key={uuid()} className={`post post-${organiser.post}`}>
                        {postTypeToString(organiser.post)}
                    </li>,
                    <li key={uuid()}>
                        {organiser.name}
                    </li>
                ];
        });

        return (
            <Row>
                <Col>
                    <h3>Rendezők</h3>
                    <ul className="organisers">
                        {organiserItems}
                    </ul>
                </Col>
            </Row>
        );
    }

    return null;
}

export default Organisers;